import * as db from '../../db'
// import firebase from 'firebase'
import _ from 'lodash'

export const RECEIVE_ITEMS = 'RECEIVE_ITEMS'
export const LOADING_ITEMS = 'LOADING_ITEMS'

// initial state
const state = {
  loading: false,
  items: {}
}

// getters
const getters = {
  items: state => _.values(state.items),
  loading: state => state.loading
}

// actions
const actions = {
  getItems({ commit }) {
    commit(LOADING_ITEMS, true)
    db.items.onSnapshot(function(snapshot) {
      let items = {}
      snapshot.forEach(doc => {
        let item = doc.data()
        item.id = doc.id
        items[item.id] = item
      })
      commit(RECEIVE_ITEMS, { items })
    })
    commit(LOADING_ITEMS, false)
  }
}

// mutations
const mutations = {
  [RECEIVE_ITEMS](state, { items }) {
    state.items = items
  },
  [LOADING_ITEMS](state, value) {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/item.js